import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Tab_01 from "../../images/services/ac/Design.webp";
import Tab_02 from "../../images/services/ac/Automate.webp";
import Tab_03 from "../../images/services/ac/Transform.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Our Forte</h2>
                            </div>
                            <p>Transforming the decision-making process</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>274B
                                        <span>Approx. market size</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>2.5T
                                        <span>Daily data production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Design</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Automate</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Transform</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Design</h2>
                                <p>At TekRevol, automation efforts start right with a needs assessment. Our business
                                    analysts study business nature and type, niche and size, then identify the right
                                    automation opportunities in your industry, weighing them against the budgets and
                                    expected ROI. This follows by designing a detailed roadmap of automation steps
                                    highlighting the priority areas.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_01}
                                    effect="blur" alt="Conventional AI Apps" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Automate</h2>
                                <p>The design stage follows data collection and processing, algorithms' technical
                                    development, and systems' deployment via digital assets like websites, apps, and
                                    SaaS programs.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_02}
                                    effect="blur" alt="Chatbots" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Transform</h2>
                                <p>We manage transformation and keep improving the self-learning systems for increased
                                    accuracy and productivity. The deployed Ai systems get mature as more data
                                    collection in the databases.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_03}
                                    effect="blur" alt="Datacenters for BI" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;